export default __webpack_public_path__ + "static/media/css.0c2690a2.webp";